/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, computed, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { MiniGameService } from 'src/app/pages/minigame/minigame.service';
import { GameApi } from 'src/app/shared/apis/game.api';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';

@Component({
  selector: 'app-game-unit',
  templateUrl: './game-unit.component.html',
  styleUrls: ['./game-unit.component.scss'],
})
export class GameUnitComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    private appService: AppService,
    private miniGameService: MiniGameService,
    private gameApi: GameApi,
    private localStorageService: LocalStorageService,
  ) {}

  domain = window.location.origin;
  /**默认图片 */
  defaultImg = computed(() => this.miniGameService.defaultImg);

  logined: boolean = false;

  isLoading: boolean = false;

  /**卡片数据 */
  @Input() item: any | null = null;

  /**加载中，覆盖白色骨架，禁用交互 */
  @Input() loading: boolean = false;

  /**宽高比 */
  @Input() ratio: number = 3 / 4;

  /**是否是用于显示厂商logo */
  @Input() isProvider: boolean = false;

  /**是否显示收藏按钮 */
  @Input() hasFavorite: boolean = true;

  @Output() clickItem: EventEmitter<any> = new EventEmitter();
  @Output() afterClickItem: EventEmitter<any> = new EventEmitter();

  url: string = '';

  isGameUnit!: boolean;

  ngOnInit() {
    this.isGameUnit = this.item && ('returnToPlayer' in this.item || 'bankerAdvantage' in this.item);

    this.logined = Boolean(this.localStorageService.loginToken);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.url = this.getUrl(changes?.item?.currentValue || null);
  }

  getUrl(item: any | null): string {
    if (!item) return '';
    if (item?.webRedirectUrl) {
      return `${this.appService.languageCode}/${item.webRedirectUrl}`;
    } else if (item?.isFullScreen) {
      // 大屏幕打开
      return `${this.appService.languageCode}/play/${item.providerCatId}/${item.gameId}`;
    } else if (item?.providerCatId && item?.providerCatId == 'GBGame-3' && !this.isProvider) {
      // 原创游戏专属跳转
      return `${this.appService.languageCode}/original/${item.gameId.toLowerCase()}`;
    } else if (item?.providerCatId && item?.gameId) {
      // 普通点击
      return `${this.appService.languageCode}/casino/games/${item.providerCatId}/${item.gameId}`;
    } else if (this.isProvider) {
      // 厂商点击(此處已包含原創遊戲跳轉 不需另外判斷)
      if (item?.secondaryPage) {
        return `${this.appService.languageCode}/casino/provider/${item.providerCatId}`;
      } else {
        return `${this.appService.languageCode}/play/${item.providerCatId}`;
      }
    }
    return '#';
  }

  onClickItem() {
    if (!this.item) return;
    const item = this.item;
    this.router.navigateByUrl(this.url);
    this.clickItem.emit(item);
    this.afterClickItem.emit(item);
  }

  /**添加或删除收藏 */
  onLikeClick(item: any) {
    if (!item || this.isLoading) return;

    this.isLoading = true;

    if (item.isFavorite) {
      //remove
      this.gameApi
        .postRemoveFavoriteGame(item.id)
        .pipe(
          catchError(error => {
            console.error('移除收藏失敗:', error);
            this.isLoading = false;
            return of({ success: false, data: null }); // 防止訂閱崩潰
          }),
        )
        .subscribe(res => {
          if (res?.success && res?.data) {
            this.miniGameService.miniGameFavoriteNumber$.next(res.data.favoriteCount);
            this.miniGameService.updateAllFavoriteIds();
          }
          this.isLoading = false;
        });
    } else {
      //add
      this.gameApi
        .postAddFavoriteGame(item.id)
        .pipe(
          catchError(error => {
            console.error('添加收藏失敗:', error);
            this.isLoading = false;
            return of({ success: false, data: null }); // 防止訂閱崩潰
          }),
        )
        .subscribe(res => {
          if (res.success && res?.data) {
            this.miniGameService.miniGameFavoriteNumber$.next(res.data.favoriteCount);
            this.miniGameService.updateAllFavoriteIds();
          }
          this.isLoading = false;
        });
    }
  }
}
